import { useState } from 'react';
import { Trans } from '../i18n/Trans';
import { ApiHelper } from '../helper/ApiHelper';

export interface PublicUser {
  id: number;
  username: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  mustChange: boolean;
}

interface LoginResp {
  token: string;
  user: PublicUser;
  mustChangeReason?: string;
}

/** 登录：只要邮箱 + 密码。（后端也接受用管理员账号名登录，页面上不暴露。） */
export function LoginPage({
  onLogin, onGoRegister, onCancel, embedded = false,
}: { onLogin: (u: PublicUser) => void; onGoRegister: () => void; onCancel: () => void; embedded?: boolean }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr('');
    setBusy(true);
    try {
      const r = await ApiHelper.call<LoginResp>('/api/auth/login', 'POST',
        { username: email.trim(), password });
      ApiHelper.setToken(r.token);
      onLogin(r.user);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={embedded ? 'login-embed' : 'login-page'}>
      <div className="login-card">
        <div className="login-title">{Trans.t('login.title')}</div>
        <p className="login-sub">{Trans.t('app.slogan')}</p>

        <label className="login-label" htmlFor="lg-email">{Trans.t('login.email')}</label>
        <input
          id="lg-email" type="email" autoComplete="email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />

        <label className="login-label" htmlFor="lg-pw">{Trans.t('login.password')}</label>
        <input
          id="lg-pw" type="password" autoComplete="current-password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />

        {err && <div className="error-box">{err}</div>}

        <button className="login-btn" disabled={busy || !email || !password} onClick={submit}>
          {busy ? Trans.t('common.loading') : Trans.t('login.submit')}
        </button>

        <div className="login-foot">
          <button className="linkbtn" onClick={onGoRegister}>{Trans.t('login.noAccount')}</button>
          {!embedded && (
            <button className="linkbtn" onClick={onCancel}>{Trans.t('common.back')}</button>
          )}
        </div>
      </div>
    </div>
  );
}
